var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "roast-info" }, [
    _c("div", { staticClass: "roast-info__label preheader" }, [
      _vm._v(_vm._s(_vm.getRoastName) + " Roast"),
    ]),
    _c("div", {
      staticClass: "roast-info__indicator",
      class: _vm.getRoastClass,
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }